import { type UseQueryResult, useQuery } from 'react-query';
import { SandboxService } from '../../services/wealthlane-identity-services';

const useGetSandboxSharedUsers = (
    handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
    sandboxId?: string
): UseQueryResult<Array<string> | undefined, unknown> => {
    const sandboxSharedUsers = useQuery(
        ['getSandboxSharedUsers', sandboxId],
        async () => {
            return await handleRequest(
                SandboxService.getApiIdentityApiSandboxSharedUsers(sandboxId!)
            );
        },
        {
            enabled: !!sandboxId,
        }
    );

    return sandboxSharedUsers;
};

export default useGetSandboxSharedUsers;

